/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.lcd_clear = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_CLEAR);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_DIRECCION_I2C_3)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_16x9PIN`),
      ), '16x9PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_CLEAR_TOOLTIP);
  },
  getPins: function () { return ['16x9PIN']; },
  component: 'I2C',
};

// El pin 16x9PIN es decorativo: el generador usa una única instancia
// lcd(0x27,16,2) fija, como el legacy.
Blockly.Blocks.lcd_educabot = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_ROWS)
      .appendField(new Blockly.FieldDropdown([['0', '0'], ['1', '1']]), 'CURSOR_ROW')
      .appendField(Blockly.Msg.LANG_LCD_ADVANCED_COLUMNS)
      .appendField(new Blockly.FieldDropdown(
        Array.from({ length: 16 }, (_, i) => [String(i), String(i)]),
      ), 'CURSOR_COLUMN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_PINS)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_16x9PIN`),
      ), '16x9PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_DEF_TOOLTIP);
  },
  getPins: function () { return ['16x9PIN']; },
  component: 'I2C',
};

Blockly.Blocks.lcd_setBacklight = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
      ]), 'STATE')
      .appendField(Blockly.Msg.LANG_LCD_SETBACKLIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_DIRECCION_I2C_3)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_16x9PIN`),
      ), '16x9PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_SETBACKLIGHT_TOOLTIP);
  },
  getPins: function () { return ['16x9PIN']; },
  component: 'I2C',
};

Blockly.Blocks.oled_clear = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/oled.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_OLED_CLEAR);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OLED_CLEAR_TOOLTIP);
  },
  component: 'OLED',
};

Blockly.Blocks.oled_text = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/oled.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_OLED_TEXT);
    this.appendValueInput('NAME')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_OLED_TEXT_SIZE)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'],
        ['2', '2'],
        ['3', '3'],
        ['4', '4'],
      ]), 'SIZE');
    this.appendValueInput('POSX')
      .appendField(Blockly.Msg.LANG_OLED_TEXT_X)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSY')
      .appendField(Blockly.Msg.LANG_OLED_TEXT_Y)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_OLED_TEXT_OLED);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OLED_TEXT_TOOLTIP);
  },
  component: 'OLED',
};
